<template>
  <div>
    <b-row class="mb-2">
      <b-col cols="4">
        <p class="text-header">รายชื่อบริการ</p>
      </b-col>
      <b-col cols="8">
        <div class="tw-flex tw-w-full tw-justify-end">
          <div class="g-form">
            <div class="input">
              <b-form-input
                v-model="filter.keyword"
                placeholder="บริการ"

                @focus="iconSearch = true"
                @blur="iconSearch = false"
                @keyup.enter="getEventGroupList"
              ></b-form-input>
              <b-button
                class="search"
                :class="iconSearch ? 'active-border' : ''"
                @click="getEventGroupList"
              >
                <b-icon
                  stacked
                  icon="search"
                  scale="0.5"
                  variant="grey"
                ></b-icon>
              </b-button>
            </div>
          </div>
          <b-button class="btn-filter ml-2" @click="onClickOpenSideBar">
            <span class="d-none d-md-block">
              <span class="">ตัวกรอง</span>
            </span>
          </b-button>
        </div>
      </b-col>
    </b-row>

    <Table
      :items="items"
      :fields="fields"
      :isBusy="isBusy"
      :rows="rows"
      :filter="filter"
      :selectedService="selectedService"
      :disabled="disabled"
      @editService="editService"
      :pageOptions="pageOptions"
      @filterPage="filterPage"
      @select="$emit('select', $event)"
      @onChangeStatus="onChangeStatus"
    />
    <FilterService
      :visible="visible"
      @closeFilter="closeFilter"
      @searchFilter="searchFilter"
    />
  </div>
</template>

<script>
import Table from "@/views/pages/service/component/table";
import FilterService from "@/views/pages/service/component/filterService";
export default {
  name: "ServiceTable",
  components: {
    Table,
    FilterService,
  },
  props: {
    selectedService: {
      required: false,
      type: Array,
      default: () => [],
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isModal: false,
      visible: false,
      rows: 0,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "select",
          label: "",
        },
        {
          key: "eventGroupName",
          label: "บริการ",
          class: "w-200px text-nowrap",
        },
        {
          key: "categoryName",
          label: "หมวดหมู่",
          class: "w-100px",
        },
        {
          key: "brandName",
          label: "แบรนด์",
          class: "w-50px text-nowrap",
        },
        {
          key: "previewOrPublish",
          label: "สถานะ",
          class: "w-50px text-nowrap",
        },
      ],

      filter: {
        page: 1,
        take: 5,
        keyword: "",
        categoryIds: [],
        brandIds: [],
        isDisplay: null,
        previewOrPublish: null,
      },

      pageOptions: [
        { value: 5, text: "5 / หน้า" },
        { value: 10, text: "10 / หน้า" },
        { value: 15, text: "15 / หน้า" },
        { value: 20, text: "20 / หน้า" },
      ],
      levelCreateService: 12,
      levelExportLog: 15,
      loading: false,
      textModal: "",
      iconSearch: false,
    };
  },

  created() {
    this.getEventGroupList();
  },
  methods: {
    async getEventGroupList() {
      this.isBusy = true;
      const respone = await this.$services.eventgroup.getEventGroupList(
        this.filter
      );
      if (respone.result === 1) {
        const { data, count } = respone.detail;
        this.items = data;
        this.rows = count;
      }
      this.isBusy = false;
    },
    async editService(id) {
      this.$router.push(`/service/detail/${id}`);
    },
    async onChangeStatus(val) {
      const { id, previewOrPublish } = val;
      const respone = await this.$services.eventgroup.savePublish(
        id,
        previewOrPublish
      );
      if (respone.result === 0) {
        this.getEventGroupList();
      }

      this.openModalAlertText(respone.message);
    },
    filterPage(obj) {
      let { pages } = obj;
      this.filter.page = pages;
      this.getEventGroupList();
    },
    onClickOpenSideBar() {
      this.visible = true;
    },
    closeFilter() {
      this.visible = false;
    },
    searchFilter(val) {
      const { brandIds, categoryIds, previewOrPublish, isDisplay, isActive } =
        val;
      this.filter.brandIds = brandIds;
      this.filter.categoryIds = categoryIds;
      this.filter.previewOrPublish = previewOrPublish;
      this.filter.isDisplay = isDisplay;
      this.filter.isActive = isActive;

      this.getEventGroupList();
      this.visible = false;
    },
    hide() {
      this.isModal = false;
    },
    submit() {
      this.$emit("submit", this.selectedItem);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction {
  .text-header {
    color: #092d53;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
  }
}
.text-error {
  margin: 0;
  color: red;
}
// ! override
.g-form {
  width: 100%;
}

.btn-filter {
  &.right {
    float: right;
  }

  &.create {
    min-width: 110px !important;
  }
}

::v-deep .btn-filter button,
.btn-filter {
  color: var(--primary-color) !important;
  border-color: var(--primary-color);
  font-weight: 100;
  min-width: 105px;
}
.render-image {
  margin: auto;
  display: block;
  max-width: 200px;
  max-height: 95px;
  width: auto;
  height: auto;
  text-align: center;
}
.container {
  min-height: 100px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.color-red {
  color: #dc3545;
}

.color-green {
  color: #28a745;
}
</style>
